<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16dzxvN/tc-custom/9781627883856.jpg?1717183238300" alt="This image is the cover for the book Fun and Fantastical Slippers to Knit"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fun and Fantastical Slippers to Knit
      </h1>
      <p class="bookDescription body article font2">
        <b>Give the gift of spectacular slippers with these clever and creative patterns—from adorable bunnies to peas and carrots and Dorothy's ruby slippers!</b><br/><br/>Do you know someone who could use a pair of beyond-cute slippers that resemble owls or goldfish? Is there someone in your life who might enjoy relaxing indoors in court jester booties? <i>Fun and Fantastical Slippers to Knit</i> shares funny and unique slipper patterns, plus practical instructions for a variety of techniques. <br/><br/>The twenty knit slippers in this book are designed to fit kids or adults and are coveted by guys and gals alike. They represent a number of knitting styles, with some knitted and felted for extra warmth. Designed by author Mary Scott Huff, these slippers are every bit as adorable, and quirky as her fantastical hats!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Scott Huff
      </h2>
      
      <p class="authorDescription body article">Mary Scott Huff, author of Fantastical Hats to Knit (CPi, 2014) began as a classically trained actor and theatrical costume designer, but accidentally became a computer programmer somewhere along the way. In writing her first two books, The New Stranded Colorwork, and Teach Yourself Visually Color Knitting, Mary fled the realm of Information Technology to pursue a more yarn-centered way of life. The many friends she found along the way have helped her become a nationally-recognized designer, teacher and author. A native of the Pacific Northwest, Mary shares a wee little house there with her husband, two children, some Scottish Terriers, and more yarn than is strictly necessary. You can join Mary on her adventures playing with string at www.maryscotthuff.comwww.maryscotthuff.comwww.ravelry.com/designers/mary-scott-huff</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Creative Publishing international
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?367d3cce